export default __webpack_public_path__ + "static/media/iconCancelCircle.dc4259d5.svg";